import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sponsors-component sz-red--text f-24 font-weight-medium text-center mb-5" }
const _hoisted_2 = { class: "sponsors-component__list" }
const _hoisted_3 = ["src", "alt"]

import type { Sponsor } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'SponsorsComponent',
  setup(__props) {

const sponsorsList: Sponsor[] = [
    { alt: 'BNP Paribas', imageUrl: require('@/assets/images/sponsors/BNP_Paribas_logo.png?as=webp') },
    { alt: 'T-Mobile', imageUrl: require('@/assets/images/sponsors/timo.png?as=webp') }
];

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('home.sponsors')), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sponsorsList, (sponsor, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "sponsors-component__sponsor"
        }, [
          _createElementVNode("img", {
            src: sponsor.imageUrl,
            alt: sponsor.alt,
            height: "85"
          }, null, 8, _hoisted_3),
          _createVNode(_component_v_divider, {
            class: "sponsors-component__divider d-none d-sm-inline-flex",
            vertical: "",
            opacity: "1"
          })
        ])
      }), 64))
    ])
  ]))
}
}

})